// extracted by mini-css-extract-plugin
export var content = "_4c-3";
export var list = "_4c-4";
export var settingsContent = "_4c-7";
export var settingsPanel = "_4c-8";
export var state = "_4c-6";
export var triggerBadge = "_4c-2";
export var triggerButton = "_4c-1";
export var triggerShell = "_4c-0";
export var unreadDot = "_4c-5";